import UserMenu from './UserMenu';
import './UserMenu.scss';

export default UserMenu;
